import type {
  OrganizationUnit,
  OrgChartRootDto,
  OrgChartProjectsRootDto,
  MemberSummaryDto,
} from '../types';

export const organizationUnitsMock: OrganizationUnit[] = [
  {
    id: 'unit-1',
    name: 'Dirección General',
    description: 'Dirección estratégica y toma de decisiones',
    icon: 'Building2',
    color: 'indigo-deep',
    parentId: null,
    memberCount: 1,
    createdAt: '2024-01-01T00:00:00.000Z',
    order: 0,
    depth: 0,
  },
  {
    id: 'unit-2',
    name: 'Recursos Humanos',
    description: 'Gestión del talento humano',
    icon: 'Users',
    color: 'purple-orchid',
    parentId: 'unit-1',
    memberCount: 2,
    createdAt: '2024-01-02T00:00:00.000Z',
    order: 0,
    depth: 1,
  },
  {
    id: 'unit-3',
    name: 'Finanzas',
    description: 'Administración financiera y contable',
    icon: 'ChartBar',
    color: 'green-emerald',
    parentId: 'unit-1',
    memberCount: 1,
    createdAt: '2024-01-03T00:00:00.000Z',
    order: 1,
    depth: 1,
  },
  {
    id: 'unit-4',
    name: 'Tecnología',
    description: 'Innovación y desarrollo tecnológico',
    icon: 'Layers',
    color: 'cyan-glacier',
    parentId: 'unit-1',
    memberCount: 3,
    createdAt: '2024-01-04T00:00:00.000Z',
    order: 2,
    depth: 1,
  },
  {
    id: 'unit-5',
    name: 'Reclutamiento',
    description: 'Captación de talento',
    icon: 'UserPlus',
    color: 'pink-bloom',
    parentId: 'unit-2',
    memberCount: 0,
    createdAt: '2024-01-05T00:00:00.000Z',
    order: 0,
    depth: 2,
  },
  {
    id: 'unit-6',
    name: 'Nómina',
    description: 'Gestión de compensaciones',
    icon: 'FileText',
    color: 'teal-lagoon',
    parentId: 'unit-2',
    memberCount: 1,
    createdAt: '2024-01-06T00:00:00.000Z',
    order: 1,
    depth: 2,
  },
  {
    id: 'unit-7',
    name: 'Contabilidad',
    icon: 'Calculator',
    color: 'orange-blaze',
    parentId: 'unit-3',
    memberCount: 0,
    createdAt: '2024-01-07T00:00:00.000Z',
    order: 0,
    depth: 2,
  },
  {
    id: 'unit-8',
    name: 'Cuentas por Pagar',
    icon: 'Receipt',
    color: 'yellow-gold',
    parentId: 'unit-3',
    memberCount: 1,
    createdAt: '2024-01-08T00:00:00.000Z',
    order: 1,
    depth: 2,
  },
  {
    id: 'unit-9',
    name: 'Desarrollo',
    description: 'Equipo de desarrollo de software',
    icon: 'Code',
    color: 'magenta-neon',
    parentId: 'unit-4',
    memberCount: 2,
    createdAt: '2024-01-09T00:00:00.000Z',
    order: 0,
    depth: 2,
  },
  {
    id: 'unit-10',
    name: 'Infraestructura',
    description: 'Servidores y cloud',
    icon: 'Server',
    color: 'coral-sunset',
    parentId: 'unit-4',
    memberCount: 1,
    createdAt: '2024-01-10T00:00:00.000Z',
    order: 1,
    depth: 2,
  },
  {
    id: 'unit-11',
    name: 'Frontend',
    icon: 'Monitor',
    color: 'cyan-polar',
    parentId: 'unit-9',
    memberCount: 1,
    createdAt: '2024-01-11T00:00:00.000Z',
    order: 0,
    depth: 3,
  },
  {
    id: 'unit-12',
    name: 'Backend',
    icon: 'Database',
    color: 'lime-zest',
    parentId: 'unit-9',
    memberCount: 1,
    createdAt: '2024-01-12T00:00:00.000Z',
    order: 1,
    depth: 3,
  },
];

export const orgChartMock: OrgChartRootDto = {
  tenantId: 'tenant-1',
  tenantName: 'Innovaforce',
  tenantAvatarUrl: null,
  totalMembers: 8,
  totalProjects: 5,
  unassignedMembers: [
    {
      id: 'member-unassigned-1',
      organizationMemberId: 'member-unassigned-1',
      projectMemberId: null,
      displayName: 'Carlos Mendoza',
      avatarUrl: null,
      jobTitle: 'Consultor Externo',
      completedTasksCount: 2,
      totalTasksCount: 4,
    },
  ],
  areas: [
    {
      id: 'unit-1',
      name: 'Dirección General',
      color: 'indigo-deep',
      icon: 'Building2',
      members: [
        {
          id: 'member-1',
          organizationMemberId: 'member-1',
          projectMemberId: null,
          displayName: 'Ana García',
          avatarUrl: null,
          jobTitle: 'Directora General',
          completedTasksCount: 8,
          totalTasksCount: 10,
        },
      ],
      children: [
        {
          id: 'unit-2',
          name: 'Recursos Humanos',
          color: 'purple-orchid',
          icon: 'Users',
          members: [
            {
              id: 'member-2',
              organizationMemberId: 'member-2',
              projectMemberId: null,
              displayName: 'Luis Pérez',
              avatarUrl: null,
              jobTitle: 'Jefe de RRHH',
              completedTasksCount: 5,
              totalTasksCount: 9,
            },
            {
              id: 'member-3',
              organizationMemberId: 'member-3',
              projectMemberId: null,
              displayName: 'María Torres',
              avatarUrl: null,
              jobTitle: 'Analista de Talento',
              completedTasksCount: 3,
              totalTasksCount: 6,
            },
          ],
          children: [
            {
              id: 'unit-5',
              name: 'Reclutamiento',
              color: 'pink-bloom',
              icon: 'UserPlus',
              members: [],
              children: [],
            },
            {
              id: 'unit-6',
              name: 'Nómina',
              color: 'teal-lagoon',
              icon: 'FileText',
              members: [
                {
                  id: 'member-4',
                  organizationMemberId: 'member-4',
                  projectMemberId: null,
                  displayName: 'Roberto Sánchez',
                  avatarUrl: null,
                  jobTitle: 'Especialista de Nómina',
                  completedTasksCount: 7,
                  totalTasksCount: 7,
                },
              ],
              children: [],
            },
          ],
        },
        {
          id: 'unit-4',
          name: 'Tecnología',
          color: 'cyan-glacier',
          icon: 'Layers',
          members: [],
          children: [
            {
              id: 'unit-9',
              name: 'Desarrollo',
              color: 'magenta-neon',
              icon: 'Code',
              members: [
                {
                  id: 'member-5',
                  organizationMemberId: 'member-5',
                  projectMemberId: null,
                  displayName: 'Sofía Ramírez',
                  avatarUrl: null,
                  jobTitle: 'Tech Lead',
                  completedTasksCount: 12,
                  totalTasksCount: 15,
                },
                {
                  id: 'member-6',
                  organizationMemberId: 'member-6',
                  projectMemberId: null,
                  displayName: 'Diego Herrera',
                  avatarUrl: null,
                  jobTitle: 'Desarrollador Senior',
                  completedTasksCount: 4,
                  totalTasksCount: 11,
                },
              ],
              children: [
                {
                  id: 'unit-11',
                  name: 'Frontend',
                  color: 'cyan-polar',
                  icon: 'Monitor',
                  members: [
                    {
                      id: 'member-7',
                      organizationMemberId: 'member-7',
                      projectMemberId: null,
                      displayName: 'Elena Vega',
                      avatarUrl: null,
                      jobTitle: 'Frontend Developer',
                      completedTasksCount: 6,
                      totalTasksCount: 8,
                    },
                  ],
                  children: [],
                },
                {
                  id: 'unit-12',
                  name: 'Backend',
                  color: 'lime-zest',
                  icon: 'Database',
                  members: [
                    {
                      id: 'member-8',
                      organizationMemberId: 'member-8',
                      projectMemberId: null,
                      displayName: 'Andrés Castro',
                      avatarUrl: null,
                      jobTitle: 'Backend Developer',
                      completedTasksCount: 9,
                      totalTasksCount: 13,
                    },
                  ],
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const orgChartProjectsMock: OrgChartProjectsRootDto = {
  tenantId: 'tenant-1',
  tenantName: 'Innovaforce',
  tenantAvatarUrl: null,
  totalMembers: 8,
  totalProjects: 3,
  projects: [
    {
      id: 'project-1',
      name: 'Plataforma de Análisis',
      status: 'active',
      color: '#299ff9',
      areaCount: 2,
      memberCount: 3,
      unassignedMembers: [],
      areas: [
        {
          id: 'unit-4',
          name: 'Tecnología',
          color: 'cyan-glacier',
          icon: 'Layers',
          members: [
            {
              id: 'member-5',
              organizationMemberId: 'member-5',
              projectMemberId: null,
              displayName: 'Sofía Ramírez',
              avatarUrl: null,
              jobTitle: 'Tech Lead',
              completedTasksCount: 12,
              totalTasksCount: 15,
            },
            {
              id: 'member-6',
              organizationMemberId: 'member-6',
              projectMemberId: null,
              displayName: 'Diego Herrera',
              avatarUrl: null,
              jobTitle: 'Desarrollador Senior',
              completedTasksCount: 4,
              totalTasksCount: 11,
            },
          ],
          children: [],
        },
        {
          id: 'unit-1',
          name: 'Dirección General',
          color: 'indigo-deep',
          icon: 'Building2',
          members: [
            {
              id: 'member-1',
              organizationMemberId: 'member-1',
              projectMemberId: null,
              displayName: 'Ana García',
              avatarUrl: null,
              jobTitle: 'Directora General',
              completedTasksCount: 8,
              totalTasksCount: 10,
            },
          ],
          children: [],
        },
      ],
    },
    {
      id: 'project-2',
      name: 'Rediseño Web',
      status: 'active',
      color: '#7310ca',
      areaCount: 1,
      memberCount: 1,
      unassignedMembers: [
        {
          id: 'member-unassigned-1',
          organizationMemberId: 'member-unassigned-1',
          projectMemberId: null,
          displayName: 'Carlos Mendoza',
          avatarUrl: null,
          jobTitle: 'Consultor Externo',
          completedTasksCount: 2,
          totalTasksCount: 4,
        },
      ],
      areas: [
        {
          id: 'unit-11',
          name: 'Frontend',
          color: 'cyan-polar',
          icon: 'Monitor',
          members: [
            {
              id: 'member-7',
              organizationMemberId: 'member-7',
              projectMemberId: null,
              displayName: 'Elena Vega',
              avatarUrl: null,
              jobTitle: 'Frontend Developer',
              completedTasksCount: 6,
              totalTasksCount: 8,
            },
          ],
          children: [],
        },
      ],
    },
    {
      id: 'project-3',
      name: 'App Móvil',
      status: 'paused',
      color: '#25cedd',
      areaCount: 1,
      memberCount: 1,
      unassignedMembers: [],
      areas: [
        {
          id: 'unit-12',
          name: 'Backend',
          color: 'lime-zest',
          icon: 'Database',
          members: [
            {
              id: 'member-8',
              organizationMemberId: 'member-8',
              projectMemberId: null,
              displayName: 'Andrés Castro',
              avatarUrl: null,
              jobTitle: 'Backend Developer',
              completedTasksCount: 9,
              totalTasksCount: 13,
            },
          ],
          children: [],
        },
      ],
    },
  ],
};

export function memberSummaryMock(memberId: string): MemberSummaryDto {
  const seed = memberId.split('').reduce((acc, ch) => (acc * 31 + ch.charCodeAt(0)) & 0xffff, 0);
  const total = 4 + (seed % 8);
  const completed = Math.min(total - 1, 1 + (seed % 4));
  const overdue = 1 + ((seed >> 4) % 3);
  const active = Math.max(0, total - completed - overdue);
  const efficiency = 55 + (seed % 45);

  return {
    member: {
      id: memberId,
      displayName: 'Colaborador',
      avatarUrl: null,
    },
    totalTasksCount: total,
    completedTasksCount: completed,
    activeTasksCount: active,
    overdueTasksCount: overdue,
    efficiencyPercent: efficiency,
    overdueTasks: Array.from({ length: Math.min(overdue, 3) }, (_, i) => ({
      id: `task-${memberId}-${i}`,
      title: [
        'Implementar módulo de reportes',
        'Revisión de código PR #42',
        'Documentar API de pagos',
      ][i % 3],
      priority: 4 - (i % 4),
      startDate: '2026-04-01T00:00:00.000Z',
      dueDate: '2026-05-10T00:00:00.000Z',
      estimatedHours: 4 + i * 2,
      totalTrackedHours: 2 + i,
    })),
  };
}
